import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { Grid, Typography } from '@mui/material';
import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined';
import { useTranslation } from '../../../../shared/hooks';
import * as translations from './intl';
import { Button } from '../../../../components';
import {
  getLanguage,
  getPartnerId,
  getPartnerName,
  getCountryCode,
  getInstanceEnv,
} from '../../../../shared/constants/globalConstants';

const classes = {
  container: {
    padding: '30px',
  },
  boldTitle: {
    fontWeight: 400,
  },
  marginButton: {
    marginTop: '20px',
  },
};

function ConfirmEmailAlert() {
  const navigate = useNavigate();
  const { locale } = useTranslation({
    translationsFile: translations,
  });

  const { TITLE, SUBTITLE, BUTTON_GO_TO_HOME } = locale;

  useEffect(() => {
    const isNewUserLoggedIn = true;

    if (isNewUserLoggedIn) {
      window.dataLayer.push({
        subsidary_name: 'axa_partners',
        business_unit: 'customer_and_solutions',
        business_line: 'travel_solutions',
        digital_business_process: 'assistance_request',
        global_digital_asset: 'doctor_please',
        partner_id: getPartnerId(),
        partner_name: getPartnerName(),
        country: getCountryCode(),
        language: getLanguage(),
        instance_environment: getInstanceEnv(),
        user_logged: 'true',
        page_name: 'confirm email address',
        event: 'page_view',
      });
    }
  }, []);

  return (
    <>
      <Grid container sx={classes.container}>
        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
          <FeedbackOutlinedIcon color="error" fontSize="large" />
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
          <Typography color="error" variant="h4" sx={classes.boldTitle}>
            {TITLE}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
          <Typography color="text" variant="subtitle1">
            {SUBTITLE}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
          <Button
            text={BUTTON_GO_TO_HOME}
            variant="outlined"
            color="primary"
            sx={classes.marginButton}
            onClick={() => {
              if (navigator.onLine) {
                window.location.href = '/login';
              } else {
                console.log('ConfirmEmailAlert - OFFLINE - not reloading page');
              }
            }}
          />
        </Grid>
      </Grid>
    </>
  );
}

export default ConfirmEmailAlert;
